import type { HTMLElementConvertOption } from '@lumapps/wrex/serialization/html/fromHTML/types';
import { matchAttribute } from '@lumapps/wrex/serialization/html/fromHTML/utils';

import { CLASSNAME } from '../../../components/blocks/LinkPreview';
import { LINK_PREVIEW } from '../../../constants';
import { createLinkPreview } from '../../../utils/createLinkPreview';

type ElementTypes = typeof LINK_PREVIEW;

/**
 * Element convert options.
 *
 * Warning: the order of these options does matter!
 */
export const ELEMENTS: { [Element in ElementTypes]: HTMLElementConvertOption<Element> } = {
    [LINK_PREVIEW]: {
        type: LINK_PREVIEW,
        test: matchAttribute('className', new RegExp(CLASSNAME)),
        transform: ({ properties, children }: any) => {
            const dataAttr = properties?.dataLinkPreviewInfo;

            // parse from clean HTML structure (when html provided by serialize.ts)
            if (dataAttr) {
                const info = JSON.parse(dataAttr);

                // Extract title from <h4> and description from <p> children.
                const h4 = children?.find((c: any) => c.tagName === 'h4');
                const p = children?.find((c: any) => c.tagName === 'p');
                const title = h4?.children?.[0]?.value;
                const description = p?.children?.[0]?.value;

                return createLinkPreview({ ...info, title, description });
            }

            // parse from nested HTML structure (when html copied from view)
            const previewWrapper = children?.[0]?.children?.[0];
            const thumbnailWrapper = previewWrapper?.children?.[0];
            const contentWrapper = previewWrapper?.children?.[1];

            const url = contentWrapper?.children?.[0]?.children?.[0]?.properties?.href ?? '';
            const title = contentWrapper?.children?.[0]?.children?.[0]?.children?.[0]?.children?.[0]?.value;
            const description = contentWrapper?.children?.[1]?.children?.[0]?.value;
            const thumbnailUrl = thumbnailWrapper?.children?.[0]?.children?.[0]?.children?.[0]?.properties?.src;

            return createLinkPreview({ url, title, description, thumbnailUrl });
        },
    },
};
